import { render, staticRenderFns } from "./TPAData.vue?vue&type=template&id=c22d1cda&"
import script from "./TPAData.vue?vue&type=script&lang=js&"
export * from "./TPAData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports